// One way to write values in admin tables (design "How values are written").

export const EMPTY = "—";

const SYMBOLS = { GBP: "£", "£": "£", EUR: "€", "€": "€", USD: "$", $: "$", LKR: "Rs " };

/** £9.99 — currency code or symbol, defaults to GBP. */
export function formatMoney(amount, currency = "GBP") {
  if (amount === null || amount === undefined || amount === "") return EMPTY;
  const n = Number(amount);
  if (!Number.isFinite(n)) return EMPTY;
  const key = String(currency || "GBP").trim().toUpperCase();
  const sym = SYMBOLS[key] ?? SYMBOLS[String(currency).trim()] ?? `${key} `;
  return `${n < 0 ? "-" : ""}${sym}${Math.abs(n).toFixed(2)}`;
}

const toDate = (value) => {
  if (!value) return null;
  // "2026-10-01 14:05:00" from MySQL is not ISO for Safari.
  const d = new Date(typeof value === "string" && /^\d{4}-\d{2}-\d{2} /.test(value) ? value.replace(" ", "T") : value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** 1 Oct 2026 */
export function formatDate(value) {
  const d = toDate(value);
  return d ? d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : EMPTY;
}

/** 1 Oct 2026, 14:05 */
export function formatDateTime(value) {
  const d = toDate(value);
  if (!d) return EMPTY;
  return `${formatDate(d)}, ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
}

/** checkout_abandoned → Checkout abandoned */
export function humanize(code) {
  if (code === null || code === undefined || code === "") return EMPTY;
  const s = String(code).replace(/[_-]+/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

/** pi_3ULhAEIWJnxhiR1d0ZnNzO1u → pi_3ULh…NzO1u */
export function shortId(id, head = 7, tail = 5) {
  if (!id) return EMPTY;
  const s = String(id);
  return s.length <= head + tail + 1 ? s : `${s.slice(0, head)}…${s.slice(-tail)}`;
}

/** Empty-safe display value. */
export function orDash(value) {
  return value === null || value === undefined || value === "" ? EMPTY : value;
}

/** Two lines then "…" (put the full text in a title/tooltip). */
export const clampSx = (lines = 2) => ({
  display: "-webkit-box",
  WebkitLineClamp: lines,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  wordBreak: "break-word",
});
